import { createApiClient, ApiProblemError } from "@guestpilot/api-client";
import { clearSsoCache, getSsoToken } from "../teams";

let locale: string | undefined;
let onUnauthorized: (() => void) | undefined;

/** The single bearer-injection point of the frontend (standards/frontend): the Teams SSO token. */
export const api = createApiClient({
  getToken: getSsoToken,
  getLocale: () => locale,
  onUnauthorized: () => {
    clearSsoCache();
    onUnauthorized?.();
  },
});

export function configureApi(opts: { locale?: string; onUnauthorized?: () => void }): void {
  if (opts.locale) locale = opts.locale;
  if (opts.onUnauthorized) onUnauthorized = opts.onUnauthorized;
}

export { ApiProblemError };

/** A new idempotency key per user intention (a retried click replays the first response, 24 h). */
export const newKey = (): string =>
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
